import { createElement } from '@gn-audio/core/common/templating';
import { BasketEmailSenderComponent } from '../basket-email-sender/basket-email-sender.component';
import './basket-email-content.component.scss';
import template from './basket-email-content.component.html';
var BasketEmailContentComponent = /** @class */ (function () {
    function BasketEmailContentComponent() {
        var _this = this;
        this.show = function () {
            var _a;
            (_a = _this.element) === null || _a === void 0 ? void 0 : _a.classList.add("visible" /* CssClass.Visible */);
        };
        this.hide = function () {
            var _a;
            (_a = _this.element) === null || _a === void 0 ? void 0 : _a.classList.remove("visible" /* CssClass.Visible */);
        };
        this.toggle = function () {
            var _a;
            (_a = _this.element) === null || _a === void 0 ? void 0 : _a.classList.toggle("visible" /* CssClass.Visible */);
        };
        this.reset = function () {
            _this.header.classList.remove("hidden" /* CssClass.Hidden */);
            _this.subHeader.classList.remove("hidden" /* CssClass.Hidden */);
            _this.thankYou.classList.remove("visible" /* CssClass.Visible */);
            _this.sender.reset();
        };
        this.showThankYou = function () {
            var _a, _b;
            (_a = _this.sender) === null || _a === void 0 ? void 0 : _a.hide();
            _this.header.classList.add("hidden" /* CssClass.Hidden */);
            _this.subHeader.classList.add("hidden" /* CssClass.Hidden */);
            (_b = _this.thankYou) === null || _b === void 0 ? void 0 : _b.classList.add("visible" /* CssClass.Visible */);
        };
    }
    BasketEmailContentComponent.prototype.render = function (_a) {
        var container = _a.container, translations = _a.translations, onSubmit = _a.onSubmit;
        this.element = createElement(template, {}, translations);
        container.appendChild(this.element);
        this.thankYou = this.element.querySelector('.basket-email-content__thank-you');
        this.header = this.element.querySelector('.basket-email-content__header');
        this.subHeader = this.element.querySelector('.basket-email-content__sub-header');
        this.sender = new BasketEmailSenderComponent();
        this.sender.render({ container: this.element, onSubmit: onSubmit, translations: translations });
    };
    BasketEmailContentComponent.prototype.destroy = function () {
        var _a, _b;
        (_a = this.sender) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = this.element) === null || _b === void 0 ? void 0 : _b.remove();
    };
    return BasketEmailContentComponent;
}());
export { BasketEmailContentComponent };
